import { render, staticRenderFns } from "./FilterPills.vue?vue&type=template&id=0390a3a0"
import script from "./FilterPills.vue?vue&type=script&lang=js"
export * from "./FilterPills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports